<template>
    <div class="question-list">
        <statistics-question-card
            class="mb-1"
            v-for="(item, index) in testStatisticSessionDetails"
            :key="index"
            :row-number="index + 1"
            :question="item"
        />
    </div>
</template>

<script>
import StatisticsQuestionCard from "./StatisticsQuestionCard";
import {mapGetters} from "vuex";

export default {
    name: "QuestionList",
    components: {StatisticsQuestionCard},
    computed: {
        ...mapGetters('tests', [
            'trans',
            'testStatisticSessionDetails',
        ]),
    },
}
</script>